
const baseProtocal = window.location.href.split('://')[0] 
console.log('baseProtocal',baseProtocal)
//  export const addressUrl = 'http://192.168.3.242:9102/'
// export const addressUrl = 'http://192.168.3.100:9102/'
export const addressUrl = `${baseProtocal}://diagadmin.szfcar.com/diagadmin/` // 正式
// export const addressUrl = 'http://218.17.140.188:8800/diagapi' // 
// export const addressUrl = 'http://192.168.3.53:9102/'//
// export const addressUrl = 'http://192.168.3.170:9102/'//
// export const addressUrl = `${baseProtocal}://192.168.3.242:9102/` // 测试
// export const addressUrl = `${baseProtocal}://218.17.140.188:8800/dadminapi/` // 测试
// export const addressUrl = `${baseProtocal}://192.168.3.229:9102/` // 测试
// export const addressUrl = `${baseProtocal}://192.168.3.228:9110/` // 测试
// export const addressUrl = `${baseProtocal}://192.168.3.242:9110/` // 测试
// export const addressUrl = 'http://192.168.3.170:9102/' // 测试
// export const addressUrl = 'http://192.168.3.245:9202/' // 测试/
// export const addressUrl = 'http://192.168.3.170:9102/' // 测试/
// export const addressUrl = 'http://192.168.3.91:9102/'
// export const addressUrl = 'http://218.17.140.188:8800/diagapi'

// export const addressUrl = 'http://192.168.3.119:9000/fcar-manager/' // 通过网关测试


// WEBPACK FOOTER //
// ./src/assets/url-public.js